import { MEDIA_QUERY_HEADER } from './constants';
import { DataSetProps } from './types';

export const onlyRenderInDesktop: DataSetProps = {
  dataSet: { mediaquery: MEDIA_QUERY_HEADER },
};
